import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import FiltersBooleanBody from './filtersBooleanBody'
import PerformingRightsOrganizationsIcon from '../../../shared/components/icons/performingRightsOrganizations'

const FiltersProMusic = ({
  locationParams,
  history,
  isAtBottom,
  count,
  makeSearchLink
}) => {
  const isChecked = locationParams.include_pro_affiliated !== 'false'

  const onChange = event => {
    const checkedValue = event.target.checked
    let newQuery = Object.assign({}, locationParams)
    delete newQuery.page

    newQuery.include_pro_affiliated = !!checkedValue

    history.push(makeSearchLink(newQuery))
  }

  return (
    <FiltersBooleanBody
      name="include_pro_affiliated"
      label="Include P.R.O. Music"
      onChange={onChange}
      isChecked={isChecked}
      isAtBottom={isAtBottom}
      count={count}
      icon={<PerformingRightsOrganizationsIcon />}
    />
  )
}

FiltersProMusic.propTypes = {
  locationParams: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  isAtBottom: PropTypes.bool,
  count: PropTypes.number,
  makeSearchLink: PropTypes.func.isRequired
}

export const FiltersProMusicComponent = FiltersProMusic
export default withRouter(FiltersProMusic)
